import React, { useRef } from 'react'

import Text from 'components/common/Text'
import Tooltip2 from 'components/common/Tooltip2.0'
import useToggleHandler from 'hooks/useToggleHandler'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'

import { Wrapper, Menu } from './styles'

const Activities = () => {
    const activitiesRef = useRef()

    const { open: isOpen, toggle: toggleMenu } = useToggleHandler(activitiesRef)

    const { quiz, jeopardy } = useVideoContext()
    const { isQuizMode, toggleQuiz, isQuizDisabled } = quiz
    const { isIframeShared, isIFrameDisabled, toggleIframeShare } = jeopardy

    const menu = [
        {
            disabled: isQuizDisabled,
            onClick: () => {
                toggleQuiz()
            },
            icon: {
                src: '/assets/revamp/quiz.new.svg',
                alt: 'quiz',
            },
            copy: isQuizMode ? 'Stop quiz' : 'Start quiz',
        },
        {
            disabled: isIFrameDisabled,
            onClick: () => {
                !isIFrameDisabled && toggleIframeShare()
            },
            icon: {
                src: '/assets/revamp/jeopardy.svg',
                alt: 'jeopardy',
            },
            copy: isIframeShared ? 'Stop jeopardy' : 'Start jeopardy',
        },
    ]

    return (
        <Tooltip2
            content={isOpen ? null : 'Activities'}
            placement="bottom"
            className="hover-here"
        >
            <Wrapper onClick={toggleMenu} ref={activitiesRef}>
                <img src="/assets/revamp/control-plus.svg" alt="activities" />
                {isOpen && (
                    <Menu.Area>
                        {menu.map(item => (
                            <Menu.Item
                                key={`activity-menu-item-${item.copy}`}
                                disabled={item.disabled}
                                onClick={item.onClick}
                            >
                                <Menu.Icon>
                                    <img {...item.icon} />
                                </Menu.Icon>
                                <Menu.ItemName>
                                    <Text level="3" bold={false}>
                                        {item.copy}
                                    </Text>
                                </Menu.ItemName>
                            </Menu.Item>
                        ))}
                    </Menu.Area>
                )}
            </Wrapper>
        </Tooltip2>
    )
}

export default Activities
